import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import ConsumerGroups from "components/menu/master-files/consumer-groups/list";

const ConsumerGroupsRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={ConsumerGroups}
            />
        </Switch>
    </div>
);

export default connect()(ConsumerGroupsRouter);
